module.exports = __webpack_public_path__ + "assets/img/no-team-bg.60f955fc.png";